module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Article-a778b5db842357f1630c97ad19c52f64.svg";